<template>
  <div class="answer-player">
    <div class="answer-item" v-for="(item, index) in answerData" :key="item.questionId">
      <QuestionResolve :answerData="item" :order="index + 1" />
    </div>
    <div class="loading-box" v-if="loading">
      <van-loading size="24px" vertical class="loading-mask">
        加载中...
      </van-loading>
    </div>
    <div class="empty-msg" v-if="!loading && !answerData.length">
      <img src="@/assets/error-icon.png" alt="">
      资源已过期
    </div>
  </div>
</template>
<script>
import { getResourceContent } from "@/axios/bookUnit";
import QuestionResolve from "./QuestionResolve.vue";

export default {
  components: { QuestionResolve },
  data() {
    return {
      answerData: [],
      loading: true,
    };
  },
  created() {
    this.getResourceContent();
  },
  methods: {
    getResourceContent() {
      this.loading = true;
      getResourceContent({
        url: 'https://testnewconcept.youxuepai.com/newConcept/classNoteTraffic/question/content?debug=1',
        method: 'POST',
        body: JSON.parse(sessionStorage.getItem('answerIdList'))
      }).then((res) => {
        this.answerData = res.data || [];
        this.loading = false;
      }).catch((err) => {
        this.loading = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.answer-player {
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  background: #F5F5F7;

  .answer-item {
    background-color: #fff;
    margin-bottom: 5px;
  }

  .loading-box {
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .empty-msg {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    img {
      width: 240px;
      height: 240px;
      margin-bottom: 10px;
    }
  }
}
</style>
